// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { EarTag, EarTagSchema } from 'api/gen/EarTag';

const requiredPart = t.interface({
  bullsEarTags: t.union([t.array(EarTagSchema), t.null]),
  heifersEarTags: t.union([t.array(EarTagSchema), t.null]),
});

export const CalvesEarTagsSchema = excess(requiredPart);

export interface CalvesEarTags extends t.TypeOf<typeof CalvesEarTagsSchema> {}
